<template>
  <v-col>
    <v-card>
      <v-img
        dark
        height="250"
        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.4)"
        src="/img/51145294662_682c889a44_b.jpeg"
      >
        <v-row align="center" class="pt-16" justify="center">
          <v-col class="text-center" cols="12">
            <h2 class="text-h3 font-weight-bold mb-4">Next Launch</h2>
            <h2 class="text-h4 subheading">
              View the next launch for plan your shipping
            </h2>
          </v-col>
        </v-row>
      </v-img>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "BannerMiddleComponent",
};
</script>

<style>
</style>